import { makeTypedFetchSelectors } from '../../app/redux-fetch'
import { TENANT_ALL_BRANDING_REDUCER_NAME, TENANT_REDUCER } from './consts'
import { IBranding } from './types'

export const fetchAllBrandingSelector = makeTypedFetchSelectors<IBranding>(
  TENANT_REDUCER,
  TENANT_ALL_BRANDING_REDUCER_NAME
)
